import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { DialogTitle, DialogContent, DialogActions, Grid } from "@mui/material";
import { StyledDialog } from "../../../../common/components/Dialog";
import { StyledButton } from "../../../../common/components/Button";
import { StyledTextField } from "../../../../common/components/TextField/styles";
import { yupResolver } from "@hookform/resolvers/yup";
import { updateTermsOfPayment } from "../../../../api/termsOfPaymentApi";
import { termsOfPaymentSchema } from "../../schemas/termsOfPaymentSchema";
const UpdateTermsOfPaymentDialog = ({
  openUpdateTermsOfPayment,
  handleCloseUpdateTermsOfPayment,
  currentTermsOfPayment,
  fetchTermsOfPayments,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = useForm({
    resolver: yupResolver(termsOfPaymentSchema),
    defaultValues: {
      id: "",
      name: "",
      email: "",
      price: 0,
    },
  });

  useEffect(() => {
    let defaultValues = {};
    defaultValues.id = currentTermsOfPayment.id;
    defaultValues.serviceId = currentTermsOfPayment.serviceId;
    defaultValues.name = currentTermsOfPayment.name;
    defaultValues.email = currentTermsOfPayment.email;
    defaultValues.price = currentTermsOfPayment.price;
    reset({ ...defaultValues });
  }, [currentTermsOfPayment, reset]);

  const submitUpdateTermsOfPayment = async (values) => {
    await updateTermsOfPayment(values);
    handleCloseUpdateTermsOfPayment();
    fetchTermsOfPayments();
  };

  return (
    <div>
      <StyledDialog
        open={openUpdateTermsOfPayment}
        onClose={handleCloseUpdateTermsOfPayment}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle> Update Terms of Payment</DialogTitle>
        <form onSubmit={handleSubmit(submitUpdateTermsOfPayment)}>
          <DialogContent dividers>
            <Grid container direction="row">
              <Grid item xs={10}>
                <StyledTextField
                  variant="outlined"
                  label="Terms Of Payment"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={errors.name}
                  helperText={errors.name?.message}
                  {...register("name")}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <StyledButton
              theme="purple"
              type="button"
              onClick={handleCloseUpdateTermsOfPayment}
            >
              Cancel
            </StyledButton>
            <StyledButton theme="green" type="submit" disabled={isSubmitting}>
              Submit
            </StyledButton>
          </DialogActions>
        </form>
      </StyledDialog>
    </div>
  );
};

export default UpdateTermsOfPaymentDialog;
